import { HexColorInput, HexColorPicker } from "react-colorful";
import {
  Popover,
  PopoverButton,
  PopoverPanel,
} from "@headlessui/react";

interface IColorPickerProps {
  value?: string | null;
  onChange: (value: string | null) => void;
}

export function ColorPicker({ value, onChange }: IColorPickerProps) {
  return (
    <Popover className={ `relative` }>
      <PopoverButton
        className={ `rounded-full w-[24px] h-[24px] border-paidniceGreen-800 border` }
        style={ { backgroundColor: value } }
      >
      </PopoverButton>

      <PopoverPanel
        className={ `absolute z-10 right-0` }
      >
        <HexColorPicker
          color={ value || `` }
          onChange={ onChange }
        />
        <HexColorInput
          color={ value || `` }
          onChange={ onChange }
          prefixed
          className={ `w-full rounded-lg p-2` }
        />
      </PopoverPanel>
    </Popover>
  );
}
